import ShortcutLink from "src/modules/shared/components/ShortcutLink";
import ReactJson from "react-json-view";
import { FC, useState } from "react";
import { Box, Collapse, Stack, Switch, Typography } from "@mui/material";
import { CardNeutral } from "src/components/card";
import { useTranslation } from "react-i18next";
import { FormControlLabel } from "@mui/material";
import { SystemLogModel } from "../types/SystemLog";
import { useNavigate } from "react-router";
import {
    PATH_CUSTOMERS,
    PATH_CUSTOMER_GROUPS,
    PATH_LOCATIONS,
    PATH_STATIONS,
    PATH_TARIFFS,
    PATH_USERS,
} from "src/routes/paths";
import UuidCopyButton from "src/components/UuidCopyButton";

interface OwnProps {
    log: SystemLogModel;
}

const Log: FC<OwnProps> = ({ log }) => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const [showLog, setShowLog] = useState<boolean>(false);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setShowLog(event.target.checked);
    };

    const resolvePath = (type: string, details: string, entityId: string) => {
        const parsed = JSON.parse(details);

        switch (type) {
            case "CompanyCustomer":
                return PATH_CUSTOMERS + `?id=${entityId}`;
            case "CompanyCustomerGroup":
                return PATH_CUSTOMER_GROUPS + `?id=${entityId}`;
            case "CompanyUser":
                return PATH_USERS + `?id=${entityId}`;
            case "UserInvitation":
                return PATH_USERS + `?email=${parsed.email}`;
            case "Location":
                return PATH_LOCATIONS + `?id=${entityId}`;
            case "Station":
                return PATH_STATIONS + `?identifier=${entityId}`;
            case "Tariff":
                return PATH_TARIFFS + `?id=${entityId}`;
            default:
                return "";
        }
    };

    const resolveObjectName = (log: SystemLogModel) => {
        const parts = log.entityType.split("\\");
        return parts[parts.length - 1];
    };

    const path = resolvePath(resolveObjectName(log), log.details, log.entityId);

    return (
        <>
            <Box sx={{ display: "flex", justifyContent: "space-between" }}>
                <Stack>
                    {path ? (
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <UuidCopyButton uuid={log.entityId} />
                            <ShortcutLink
                                onClick={() => {
                                    navigate(path);
                                }}
                            />
                        </Box>
                    ) : (
                        <Typography variant="helper" sx={{ fontStyle: "italic" }}>
                            {t("shared.na")}
                        </Typography>
                    )}
                </Stack>
                <FormControlLabel
                    checked={showLog}
                    control={<Switch onChange={handleChange} />}
                    label={
                        <Typography variant="tableOverline" sx={{ minWidth: 51 }}>
                            {showLog ? t("systemLogs.list.hideLog") : t("systemLogs.list.showLog")}
                        </Typography>
                    }
                />
            </Box>
            <Collapse in={showLog}>
                <CardNeutral sx={{ mt: 2.5 }}>
                    <ReactJson src={JSON.parse(log.details)} iconStyle="circle" />
                </CardNeutral>
            </Collapse>
        </>
    );
};

export default Log;
